import { ReactNode, Suspense } from 'react';
import { LoadingOverlay } from '@cbridge-tools/overlay';

export const SuspenseRoute = ({ element }: { element: ReactNode }) => (
  <Suspense fallback={<LoadingOverlay />}>
    {element}
  </Suspense>
);
